module.exports = __webpack_public_path__ + "img/appIcon-apps--CustomerBase.2e333c52.svg";